module.exports = __webpack_public_path__ + "static/img/OOSH_082.e0753c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_082.jpg
// module id = a9N1
// module chunks = 170